import { TermRepository } from './domain/repositories/TermRepository'
import { placeFetchAdapter } from './external/placeFetchAdapter'
import { termRepositoryAdapter } from './infra/termRepositoryAdapter'

export const termInstance = Term(termRepositoryAdapter(placeFetchAdapter))

export function Term(termRepository: TermRepository) {
  return {
    async getUserTermList(userId: string, language: string) {
      return await termRepository.getUserTermList(userId, language)
    },
    async userAcceptTerm(userId: string, device: string) {
      return await termRepository.userAcceptTerm(userId, device)
    }
  }
}
